module.exports = __webpack_public_path__ + "static/img/bg1.ffc3082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/bg1.png
// module id = WFIz
// module chunks = 70